<template>
    <div
        class="modal"
        id="helpcenterModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="helpcenterModal"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content p-3">
                <div class="modal-header">
                    <h5 class="modal-title" id="helpcenterModalLabel">
                        <h3>Wie können wir dir helfen?</h3>
                    </h5>

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times-circle"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div>
                            <strong>Kontakt zu deinem Abo-Anbieter</strong>
                        </div>
                        <div class="text-muted">
                            Wende dich direkt an deinen Anbieter, wenn du Fragen zu deinem Fahrzeug, zur
                            Verfügbarkeit oder zu Unfall und Werkstatt hast. Infos zu deinem Anbieter
                            findest du im Fahrzeuginserat oder in deinem Account.
                        </div>
                    </div>

                    <div class="mt-4 small w-100 text-center background-grey p-3" style="border-radius: 7px;">
                        <div class="text-center  d-inline-block p-1 rounded">
                            <strong>
                                <strong><i class="fal fa-info-circle"></i> Unsicher bei welchem
                                Anbieter du bist?</strong>
                            </strong>
                        </div>

                        <div>
                            <div class="text-muted">
                                Gib im Suchfeld einfach deine
                                Bestellnummer (Abonummer) ein:
                            </div>

                            <div class="d-flex align-items-center justify-content-center flex-column mt-2">
                                <div class="input-group input-group-sm w-75">
                                    <input
                                        v-model="searchModel"
                                        type="text"
                                        class="form-control"
                                        placeholder="Bestell- / Abonummer"
                                        aria-label="Suche nach Kontaktdaten des Anbieters"
                                    />
                                    <button
                                        class="btn btn-sm btn-light"
                                        type="button"
                                        @click="getSubsidiaryInformation"
                                    >
                                        <div style="width: 6ch">
                                            <span v-if="!isLoading">Suchen</span>
                                            <i v-else class="fal fa-tire fa-spin rotating-icon"></i>
                                        </div>
                                    </button>
                                </div>

                                <div v-if="searchError" class="text-primary">
                                    {{ searchError }}
                                </div>

                                <div
                                    v-if="subsidiaryInfo"
                                    class="subsidiaryInfoBox p-2 faaren-border-radius mt-2"
                                >
                                    <h6>Dein Anbieter ist:</h6>
                                    <div>{{ subsidiaryInfo?.name }}</div>
                                    <div>
                                        <a :href="'mailto:' + subsidiaryInfo?.email">
                                            {{ subsidiaryInfo?.email }}
                                        </a>
                                    </div>
                                    <div>Tel.: {{ subsidiaryInfo?.tel }}</div>
                                    <div class="mt-2">
                                        <a :href="subsidiaryInfo?.login" target="_blank">
                                            <button class="btn btn-sm btn-primary">
                                                Zum Login
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <strong>Kontakt zu FAAREN</strong>
                        <div class="text-muted">
                            Kontaktiere FAAREN, wenn es um technische Hilfe bei deiner Buchung oder deinem Account geht oder bei Fragen zum Zahlungsmanagement.
                        </div>
                    </div>

                    <div class="col-12 col-lg-9 pt-4" style="margin: 0 auto">
                        <div @click="redirect('phone')">
                            <ContactModalIconContainer
                                v-if="navbarModalPhoneNumber == true"
                                title="093 02 / 657 057 0"
                                subtitle="Mo. - Fr. · 09:00 - 17:00 Uhr"
                                icon="fal fa-phone"
                                icon-color="#d6251c"
                                icon-bg="#ffedea"
                            />
                        </div>

                        <div @click="redirect('foldout')">
                            <ContactModalIconContainer
                                @click="redirect('foldout')"
                                title="WhatsApp"
                                subtitle="Schnelle, direkte und persönliche Kommunikation"
                                icon="fal fa-comment"
                                icon-color="#25D366"
                                icon-bg="#ecf7ee"
                                class="mt-4"
                            />
                        </div>

                        <div v-if="foldOutWhatsapp" class="d-flex align-items-center flex-column">
                            <div class="text-muted mt-1 mb-1">
                                <small>WhatsApp öffnen</small>
                            </div>

                            <div class="text-center">
                                <whats-app-qr />
                            </div>

                            <div>
                                <button
                                    type="button"
                                    class="btn btn-outline-success btn-lg mt-3"
                                    @click.stop="redirect('whatsapp')"
                                >
                                    zu WhatsApp
                                </button>
                            </div>
                        </div>

                        <div @click="redirect('telegram')">
                            <ContactModalIconContainer
                                title="Telegram"
                                subtitle="Sicher und schnell erreichbar"
                                icon="fal fa-paper-plane"
                                icon-color="#4d9cd4"
                                icon-bg="#e8f1f8"
                                class="mt-4"
                            />
                        </div>

                        <div @click="redirect('email')">
                            <ContactModalIconContainer
                                title="kundenservice@faaren.com"
                                subtitle="Für detallierte Anfragen"
                                icon="fal fa-envelope"
                                icon-color="#17191c"
                                icon-bg="#e4e4e6"
                                class="mt-4"
                            />
                        </div>
                    </div>

                    <hr class="mt-5" />

                    <div class="text-center">
                        <strong>FAQ &amp; Hilfe</strong>
                        <div class="text-muted mt-2">Antworten auf häufig gestellte Fragen findest du in unserem Helpcenter.</div>
                        <a href="https://help.faaren.com" target="_blank" rel="noopener noreferrer" class="btn btn-light mt-3">
                            <i class="fal fa-question mr-2"></i>Zum Helpcenter
                        </a>
                    </div>

                    <hr class="mt-5" />

                    <div class="text-center">
                        <strong> Folge uns auf Social Media </strong>

                        <div class="d-flex justify-content-center">
                            <div
                                class="social-icons-bg background-grey"
                                @click="redirect('instagram')"
                            >
                                <i
                                    class="fab fa-instagram icon-size click-pointer"
                                    alt="instagram icon "
                                ></i>
                            </div>

                            <div class="social-icons-bg background-grey" @click="redirect('facebook')">
                                <i
                                    class="fab fa-facebook icon-size click-pointer"
                                    alt="facebook icon "
                                ></i>
                            </div>

                            <div class="social-icons-bg background-grey" @click="redirect('linkedin')">
                                <i
                                    class="fab fa-linkedin icon-size click-pointer"
                                    alt="linkedin icon "
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import whatsAppQr from '../atoms/texts/WhatsAppQr.vue'
    import ContactModalIconContainer from '../atoms/buttons/ContactModalIconContainer.vue'
    import GreyButton from '../atoms/buttons/GreyButton.vue'
    import axios from 'axios'

    export default {
        name: "ContactModal",

        components: {
            whatsAppQr,
            ContactModalIconContainer,
            GreyButton
        },

        props: {
            navbarModalPhoneNumber: {
                default: false,
            }
        },

        data() {
            return {
                qrCode: false,
                foldOutWhatsapp: false,
                searchModel: '',
                isLoading: false,
                subsidiaryInfo: null,
                searchError: ''
            };
        },
        methods: {
            async getSubsidiaryInformation() {
                this.isLoading = true
                this.searchError = ''
                this.subsidiaryInfo = null

                if (this.searchModel && this.searchModel.length > 12 && this.searchModel.length < 25) {
                    axios.get('/api/subscription/subsidiaryinformation/' + this.searchModel)
                    .then((data) => {
                        if (data?.data?.success) {
                            this.subsidiaryInfo = data?.data
                        } else {
                            this.searchError = 'Es konnten keine Informationen gefunden werden'
                        }
                        this.isLoading = false
                    })
                } else {
                    this.searchError = 'Fehlerhafte Bestell- / Abonummer'
                    this.isLoading = false
                }
            },

            redirect(link) {
                switch (link) {
                    case 'foldout':
                        this.foldOutWhatsapp = !this.foldOutWhatsapp
                        break
                    case 'email':
                        window.open('mailto:kundenservice@faaren.com')
                        break
                    case 'whatsapp':
                        window.open('https://wa.me/+4993026570579', '', 'noopener,noreferrer')
                        break
                    case 'phone':
                        window.open('tel:+4993026570579')
                        break
                    case 'instagram':
                        window.open('https://www.instagram.com/drivefaaren', '', 'noopener,noreferrer')
                        break
                    case 'facebook':
                        window.open('https://www.facebook.com/drivefaaren', '', 'noopener,noreferrer')
                        break
                    case 'linkedin':
                        window.open('https://www.linkedin.com/company/faaren/', '', 'noopener,noreferrer')
                        break
                    case 'telegram':
                        window.open('https://telegram.me/FAAREN_Support_bot', '', 'noopener,noreferrer')
                        break
                }
            },
        },
    }
</script>

<style scoped>
.icon-size {
    font-size: x-large;
}
.background-grey {
    background: #f8f8f8;
}
.social-icons-bg {
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1em;
    margin: 1em;
    cursor: pointer;
}
.rotating-icon {
    animation: spin 2s linear infinite;
}
</style>
